export default __webpack_public_path__ + "static/media/stone.52c06ec2.svg";